<template>
  <div v-if="userInformationStore.isFormRequired" class="flex flex-col gap-16">
    <h2 class="heading-3">{{ i18n(translations.title) }}</h2>
    <RevCard class="flex items-start justify-between gap-16 p-24">
      <RevForm
        class="w-full"
        :initial-values
        method="POST"
        :validate="validators"
      >
        <template #default="{ values, errors }">
          <UserInformationFields
            v-model:birthdate="values.birthdate"
            v-model:national-id="values.nationalId"
            :country="country as Country"
            :errors
            :with-national-id="withNationalId || userInformationWithNationalId"
          />
        </template>
      </RevForm>
    </RevCard>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Country } from '@backmarket/http-api'
import { InputAddressBirthdateValidators } from '@backmarket/nuxt-module-address/InputAddressBirthdateValidators'
import { InputAddressNationalIdValidators } from '@backmarket/nuxt-module-address/InputAddressNationalIdValidators'
import UserInformationFields from '@backmarket/nuxt-module-address/UserInformationFields.vue'
import type { NationalIdCountries } from '@backmarket/nuxt-module-address/nationalId'
import { isNationalIdRequiredForCountry } from '@backmarket/nuxt-module-address/utils/nationalId/isNationalIdRequiredForCountry'
import { isNationalIdShownForBilling } from '@backmarket/nuxt-module-address/utils/nationalId/isNationalIdShownForBilling'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevForm, makeValidate } from '@ds/components/Form'

import { useUserInformationStore } from '~/scopes/checkout/stores/userInformationStore'

import translations from './UserInformations.translations'

const props = defineProps<{
  country: string
}>()

const i18n = useI18n()
const userInformationStore = useUserInformationStore()

type FormValues = {
  birthdate: string
  nationalId: string
}

const validators = makeValidate<FormValues>({
  birthdate: InputAddressBirthdateValidators(i18n),
  nationalId: InputAddressNationalIdValidators(i18n),
})

const initialValues = computed<FormValues>(() => ({
  birthdate: userInformationStore.birthdate ?? '',
  nationalId: userInformationStore.nationalId ?? '',
}))

const withNationalId = computed(() => {
  return isNationalIdRequiredForCountry(props.country as NationalIdCountries)
})

const userInformationWithNationalId = computed(() => {
  return isNationalIdShownForBilling(props.country as Country)
})
</script>
